// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__jiLTJ","row":"ProcedureTreatmentSummary_row__2WhK9"};